export const languagesSet1 = [
  {
    text: "Abkhazian",
    link: "https://www.tomedes.com/abkhazian-translation.php",
  },
  { text: "Afrikaans", link: "https://www.tomedes.com/languages/afrikaans" },
  {
    text: "Albanian",
    link: "https://www.tomedes.com/albanian-translation.php",
  },
  { text: "Amharic", link: "https://www.tomedes.com/languages/amharic" },
  { text: "Arabic", link: "https://www.tomedes.com/languages/arabic" },
  { text: "Armenian", link: "https://www.tomedes.com/languages/armenian" },
  {
    text: "Assamese",
    link: "https://www.tomedes.com/assamese-translation.php",
  },
  { text: "Aymara", link: "https://www.tomedes.com/aymara-translation.php" },
  {
    text: "Azerbaijani",
    link: "https://www.tomedes.com/azerbaijani-translation.php",
  },
  { text: "Bashkir", link: "https://www.tomedes.com/bashkir-translation.php" },
  { text: "Basque", link: "https://www.tomedes.com/basque-translation.php" },
  {
    text: "Belarusian",
    link: "https://www.tomedes.com/belarusian-translation.php",
  },
  { text: "Bengali", link: "https://www.tomedes.com/languages/bengali" },
  { text: "Berber", link: "https://www.tomedes.com/berber-translation.php" },
  { text: "Bosnian", link: "https://www.tomedes.com/bosnian-translation.php" },
  { text: "Bulgarian", link: "https://www.tomedes.com/languages/bulgarian" },
  { text: "Burmese", link: "https://www.tomedes.com/languages/burmese" },
  { text: "Bahasa", link: "https://www.tomedes.com/bahasa-translation.php" },
  {
    text: "Cambodian",
    link: "https://www.tomedes.com/cambodian-translation.php",
  },
  { text: "Catalan", link: "https://www.tomedes.com/catalan-translation.php" },
  {
    text: "Cherokee",
    link: "https://www.tomedes.com/cherokee-translation.php",
  },
  { text: "Chewa", link: "https://www.tomedes.com/chewa-translation.php" },
  { text: "Chinese", link: "https://www.tomedes.com/languages/chinese" },
  {
    text: "Chuukese",
    link: "https://www.tomedes.com/chuukese-translation.php",
  },
  {
    text: "Corsican",
    link: "https://www.tomedes.com/corsican-translation.php",
  },
  { text: "Croatian", link: "https://www.tomedes.com/languages/croatian" },
  { text: "Czech", link: "https://www.tomedes.com/languages/czech" },
  { text: "Danish", link: "https://www.tomedes.com/languages/danish" },
  { text: "Divehi", link: "https://www.tomedes.com/divehi-translation.php" },
  { text: "Dutch", link: "https://www.tomedes.com/languages/dutch" },
];

export const languagesSet2 = [
  {
    text: "Dzongkha",
    link: "https://www.tomedes.com/dzongkha-translation.php",
  },
  {
    text: "Elfdalian",
    link: "https://www.tomedes.com/elfdalian-translation.php",
  },
  {
    text: "Esperanto",
    link: "https://www.tomedes.com/esperanto-translation.php",
  },
  {
    text: "Estonian",
    link: "https://www.tomedes.com/estonian-translation.php",
  },
  { text: "Faroese", link: "https://www.tomedes.com/faroese-translation.php" },
  { text: "Fijian", link: "https://www.tomedes.com/fijian-translation.php" },
  {
    text: "Filipino",
    link: "https://www.tomedes.com/filipino-translation.php",
  },
  { text: "Finnish", link: "https://www.tomedes.com/languages/finnish" },
  { text: "Flemish", link: "https://www.tomedes.com/flemish-translation.php" },
  { text: "French", link: "https://www.tomedes.com/languages/french" },
  { text: "Frisian", link: "https://www.tomedes.com/frisian-translation.php" },
  { text: "Fula", link: "https://www.tomedes.com/fula-translation.php" },
  {
    text: "Galician",
    link: "https://www.tomedes.com/galician-translation.php",
  },
  {
    text: "Georgian",
    link: "https://www.tomedes.com/georgian-translation.php",
  },
  { text: "German", link: "https://www.tomedes.com/languages/german" },
  { text: "Greek", link: "https://www.tomedes.com/greek-translation.php" },
  {
    text: "Greenlandic",
    link: "https://www.tomedes.com/greenlandic-translation.php",
  },
  { text: "Guarani", link: "https://www.tomedes.com/guarani-translation.php" },
  {
    text: "Gujarati",
    link: "https://www.tomedes.com/gujarati-translation.php",
  },
  {
    text: "Haitian-creole",
    link: "https://www.tomedes.com/languages/haitian-creole",
  },
  { text: "Hausa", link: "https://www.tomedes.com/hausa-translation.php" },
  {
    text: "Hawaiian",
    link: "https://www.tomedes.com/hawaiian-translation.php",
  },
  { text: "Hebrew", link: "https://www.tomedes.com/languages/hebrew" },
  { text: "Hindi", link: "https://www.tomedes.com/languages/hindi" },
  { text: "Hmong", link: "https://www.tomedes.com/hmong-translation.php" },
  { text: "Hungarian", link: "https://www.tomedes.com/languages/hungarian" },
  { text: "Ibibio", link: "https://www.tomedes.com/ibibio-translation.php" },
  {
    text: "Icelandic",
    link: "https://www.tomedes.com/icelandic-translation.php",
  },
  {
    text: "Indonesian",
    link: "https://www.tomedes.com/indonesian-translation.php",
  },
  {
    text: "Interlingua",
    link: "https://www.tomedes.com/interlingua-translation.php",
  },
];

export const languagesSet3 = [
  {
    text: "Inuktitut",
    link: "https://www.tomedes.com/inuktitut-translation.php",
  },
  { text: "Inupiaq", link: "https://www.tomedes.com/inupiaq-translation.php" },
  { text: "Irish", link: "https://www.tomedes.com/irish-translation.php" },
  { text: "Italian", link: "https://www.tomedes.com/languages/italian" },
  { text: "Igbo", link: "https://www.tomedes.com/igbo-translation.php" },
  {
    text: "Javanese",
    link: "https://www.tomedes.com/javanese-translation.php",
  },
  { text: "Japanese", link: "https://www.tomedes.com/languages/japanese" },
  { text: "Kannada", link: "https://www.tomedes.com/kannada-translation.php" },
  { text: "Kanuri", link: "https://www.tomedes.com/kanuri-translation.php" },
  {
    text: "Kashmiri",
    link: "https://www.tomedes.com/kashmiri-translation.php",
  },
  {
    text: "Kinyarwanda",
    link: "https://www.tomedes.com/languages/kinyarwanda",
  },
  { text: "Kirghiz", link: "https://www.tomedes.com/kirghiz-translation.php" },
  { text: "Konkani", link: "https://www.tomedes.com/konkani-translation.php" },
  { text: "Korean", link: "https://www.tomedes.com/languages/korean" },
  { text: "Kurdish", link: "https://www.tomedes.com/kurdish-translation.php" },
  { text: "Lao", link: "https://www.tomedes.com/languages/lao" },
  {
    text: "Laothian",
    link: "https://www.tomedes.com/laothian-translation.php",
  },
  { text: "Latvian", link: "https://www.tomedes.com/latvian-translation.php" },
  { text: "Lingala", link: "https://www.tomedes.com/lingala-translation.php" },
  {
    text: "Lithuanian",
    link: "https://www.tomedes.com/lithuanian-translation.php",
  },
  {
    text: "Macedonian",
    link: "https://www.tomedes.com/macedonian-translation.php",
  },
  {
    text: "Malagasy",
    link: "https://www.tomedes.com/malagasy-translation.php",
  },
  { text: "Malay", link: "https://www.tomedes.com/malay-translation.php" },
  {
    text: "Malayalam",
    link: "https://www.tomedes.com/malayalam-translation.php",
  },
  { text: "Maltese", link: "https://www.tomedes.com/maltese-translation.php" },
  { text: "Maori", link: "https://www.tomedes.com/maori-translation.php" },
  { text: "Marathi", link: "https://www.tomedes.com/marathi-translation.php" },
  {
    text: "Moldavian",
    link: "https://www.tomedes.com/moldavian-translation.php",
  },
  {
    text: "Mongolian",
    link: "https://www.tomedes.com/mongolian-translation.php",
  },
  { text: "Nauru", link: "https://www.tomedes.com/nauru-translation.php" },
];

export const languagesSet4 = [
  { text: "Navajo", link: "https://www.tomedes.com/languages/navajo" },
  { text: "Nepali", link: "https://www.tomedes.com/nepali-translation.php" },
  {
    text: "Norwegian",
    link: "https://www.tomedes.com/norwegian-translation.php",
  },
  { text: "Occitan", link: "https://www.tomedes.com/occitan-translation.php" },
  { text: "Oriya", link: "https://www.tomedes.com/oriya-translation.php" },
  { text: "Oromo", link: "https://www.tomedes.com/oromo-translation.php" },
  {
    text: "Papiamentu",
    link: "https://www.tomedes.com/papiamentu-translation.php",
  },
  { text: "Pashto", link: "https://www.tomedes.com/pashto-translation.php" },
  { text: "Persian", link: "https://www.tomedes.com/persian-translation.php" },
  {
    text: "Philippine",
    link: "https://www.tomedes.com/philippine-translation.php",
  },
  { text: "Polish", link: "https://www.tomedes.com/languages/polish" },
  { text: "Portuguese", link: "https://www.tomedes.com/languages/portuguese" },
  { text: "Punjabi", link: "https://www.tomedes.com/punjabi-translation.php" },
  { text: "Quechua", link: "https://www.tomedes.com/quechua-translation.php" },
  {
    text: "Romanian",
    link: "https://www.tomedes.com/romanian-translation.php",
  },
  { text: "Sami", link: "https://www.tomedes.com/sami-translation.php" },
  { text: "Samoan", link: "https://www.tomedes.com/samoan-translation.php" },
  {
    text: "Sanskrit",
    link: "https://www.tomedes.com/sanskrit-translation.php",
  },
  { text: "Serbian", link: "https://www.tomedes.com/serbian-translation.php" },
  { text: "Sesotho", link: "https://www.tomedes.com/sesotho-translation.php" },
  {
    text: "Setswana",
    link: "https://www.tomedes.com/setswana-translation.php",
  },
  { text: "Shona", link: "https://www.tomedes.com/shona-translation.php" },
  {
    text: "Simplified-english",
    link: "https://www.tomedes.com/simplified-english-translation.php",
  },
  { text: "Sindhi", link: "https://www.tomedes.com/sindhi-translation.php" },
  {
    text: "Sinhalese",
    link: "https://www.tomedes.com/sinhalese-translation.php",
  },
  { text: "Siswati", link: "https://www.tomedes.com/siswati-translation.php" },
  { text: "Slovak", link: "https://www.tomedes.com/slovak-translation.php" },
  {
    text: "Slovenian",
    link: "https://www.tomedes.com/slovenian-translation.php",
  },
  { text: "Somali", link: "https://www.tomedes.com/languages/somali" },
  { text: "Sorbian", link: "https://www.tomedes.com/sorbian-translation.php" },
];

export const languagesSet5 = [
  { text: "Spanish", link: "https://www.tomedes.com/spanish-translation.php" },
  {
    text: "Sundanese",
    link: "https://www.tomedes.com/sundanese-translation.php",
  },
  { text: "Swahili", link: "https://www.tomedes.com/languages/swahili" },
  { text: "Swedish", link: "https://www.tomedes.com/languages/swedish" },
  { text: "Syriac", link: "https://www.tomedes.com/syriac-translation.php" },
  { text: "Tajik", link: "https://www.tomedes.com/tajik-translation.php" },
  {
    text: "Tamazight",
    link: "https://www.tomedes.com/tamazight-translation.php",
  },
  { text: "Tamil", link: "https://www.tomedes.com/tamil-translation.php" },
  { text: "Tatar", link: "https://www.tomedes.com/tatar-translation.php" },
  { text: "Telugu", link: "https://www.tomedes.com/telugu-translation.php" },
  { text: "Thai", link: "https://www.tomedes.com/languages/thai" },
  { text: "Thosa", link: "https://www.tomedes.com/xhosa-translation.php" },
  { text: "Tibetan", link: "https://www.tomedes.com/tibetan-translation.php" },
  { text: "Tigrinya", link: "https://www.tomedes.com/languages/tigrinya" },
  { text: "Tongan", link: "https://www.tomedes.com/tongan-translation.php" },
  { text: "Toruba", link: "https://www.tomedes.com/yoruba-translation.php" },
  { text: "Tsonga", link: "https://www.tomedes.com/tsonga-translation.php" },
  { text: "Tulu", link: "https://www.tomedes.com/zulu-translation.php" },
  { text: "Turkish", link: "https://www.tomedes.com/languages/turkish" },
  { text: "Turkmen", link: "https://www.tomedes.com/turkmen-translation.php" },
  { text: "Twi", link: "https://www.tomedes.com/twi-translation.php" },
  { text: "Ukrainian", link: "https://www.tomedes.com/languages/ukrainian" },
  { text: "Urdu", link: "https://www.tomedes.com/urdu-translation.php" },
  { text: "Uzbek", link: "https://www.tomedes.com/uzbek-translation.php" },
  {
    text: "Vietnamese",
    link: "https://www.tomedes.com/vietnamese-translation.php",
  },
  { text: "Welsh", link: "https://www.tomedes.com/languages/welsh" },
  { text: "Wolof", link: "https://www.tomedes.com/wolof-translation.php" },
  { text: "Yiddish", link: "https://www.tomedes.com/languages/yiddish" },
];

export const languagesPairsSet1 = [
  {
    text: "Albanian to English",
    link: "https://www.tomedes.com/albanian-to-english-translation.php",
  },
  {
    text: "Arabic to English",
    link: "https://www.tomedes.com/languages/arabic",
  },
  {
    text: "Bulgarian to English",
    link: "https://www.tomedes.com/languages/bulgarian",
  },
  {
    text: "Chinese to English",
    link: "https://www.tomedes.com/languages/chinese",
  },
  {
    text: "Czech to English",
    link: "https://www.tomedes.com/languages/czech",
  },
  {
    text: "Danish to English",
    link: "https://www.tomedes.com/languages/danish",
  },
  {
    text: "Dutch to English",
    link: "https://www.tomedes.com/languages/dutch",
  },
  {
    text: "English to Albanian",
    link: "https://www.tomedes.com/english-to-albanian-translation-service.php",
  },
  {
    text: "English to Arabic",
    link: "https://www.tomedes.com/languages/arabic",
  },
  {
    text: "English to Bulgarian",
    link: "https://www.tomedes.com/languages/bulgarian",
  },
  {
    text: "English to Chinese",
    link: "https://www.tomedes.com/languages/chinese",
  },
  {
    text: "English to Croatian",
    link: "https://www.tomedes.com/languages/croatian",
  },
  {
    text: "English to Czech",
    link: "https://www.tomedes.com/languages/czech",
  },
  {
    text: "English to Danish",
    link: "https://www.tomedes.com/languages/danish",
  },
  {
    text: "English to Dutch",
    link: "https://www.tomedes.com/languages/dutch",
  },
];

export const languagesPairsSet2 = [
  {
    text: "English to Finnish",
    link: "https://www.tomedes.com/languages/finnish",
  },
  {
    text: "English to French",
    link: "https://www.tomedes.com/languages/french",
  },
  {
    text: "English to German",
    link: "https://www.tomedes.com/languages/german",
  },
  {
    text: "English to Greek",
    link: "https://www.tomedes.com/english-to-greek-translation-service.php",
  },
  {
    text: "English to Hebrew",
    link: "https://www.tomedes.com/languages/hebrew",
  },
  {
    text: "English to Icelandic",
    link: "https://www.tomedes.com/english-to-icelandic-translation-service.php",
  },
  {
    text: "English to Italian",
    link: "https://www.tomedes.com/languages/italian",
  },
  {
    text: "English to Japanese",
    link: "https://www.tomedes.com/languages/japanese",
  },
  {
    text: "English to Korean",
    link: "https://www.tomedes.com/languages/korean",
  },
  {
    text: "English to Latin",
    link: "https://www.tomedes.com/english-to-latin-translation.php",
  },
  {
    text: "English to Norwegian",
    link: "https://www.tomedes.com/languages/norwegian",
  },
  {
    text: "English to Polish",
    link: "https://www.tomedes.com/languages/polish",
  },
  {
    text: "English to Portuguese",
    link: "https://www.tomedes.com/languages/portuguese",
  },
  {
    text: "English to Romanian",
    link: "https://www.tomedes.com/languages/romanian",
  },
  {
    text: "English to Russian",
    link: "https://www.tomedes.com/languages/russian",
  },
];

export const languagesPairsSet3 = [
  {
    text: "English to Spanish",
    link: "https://www.tomedes.com/english-to-spanish-translation-service.php",
  },
  {
    text: "English to Swedish",
    link: "https://www.tomedes.com/languages/swedish",
  },
  {
    text: "English to Thai",
    link: "https://www.tomedes.com/languages/thai",
  },
  {
    text: "English to Turkish",
    link: "https://www.tomedes.com/languages/turkish",
  },
  {
    text: "Finnish to English",
    link: "https://www.tomedes.com/languages/finnish",
  },
  {
    text: "French to English",
    link: "https://www.tomedes.com/languages/french",
  },
  {
    text: "German to English",
    link: "https://www.tomedes.com/languages/german",
  },
  {
    text: "Greek to English",
    link: "https://www.tomedes.com/greek-to-english-translation-service.php",
  },
  {
    text: "Hebrew to English",
    link: "https://www.tomedes.com/languages/hebrew",
  },
  {
    text: "Icelandic to English",
    link: "https://www.tomedes.com/icelandic-to-english-translation-service.php",
  },
  {
    text: "Italian to English",
    link: "https://www.tomedes.com/languages/italian",
  },
  {
    text: "Japanese to English",
    link: "https://www.tomedes.com/languages/japanese",
  },
  {
    text: "Korean to English",
    link: "https://www.tomedes.com/languages/korean",
  },
  {
    text: "Latin to English",
    link: "https://www.tomedes.com/english-to-latin-translation-service.php",
  },
  {
    text: "Norwegian to English",
    link: "https://www.tomedes.com/languages/norwegian",
  },
];

export const languagesPairsSet4 = [
  {
    text: "Polish to English",
    link: "https://www.tomedes.com/languages/polish",
  },
  {
    text: "Portuguese to English",
    link: "https://www.tomedes.com/languages/portuguese",
  },
  {
    text: "Romanian to English",
    link: "https://www.tomedes.com/languages/romanian",
  },
  {
    text: "Russian to English",
    link: "https://www.tomedes.com/languages/russian",
  },
  {
    text: "Spanish to English",
    link: "https://www.tomedes.com/spanish-to-english-translation-service.php",
  },
  {
    text: "Swedish to English",
    link: "https://www.tomedes.com/languages/swedish",
  },
  {
    text: "Thai to English",
    link: "https://www.tomedes.com/languages/thai",
  },
  {
    text: "Turkish to English",
    link: "https://www.tomedes.com/languages/turkish",
  },
  {
    text: "Ukrainian to English",
    link: "https://www.tomedes.com/languages/ukrainian",
  },
];
